// extracted by mini-css-extract-plugin
export default {"SecondaryHeaderMain":"secondaryHeader_SecondaryHeaderMain__tMdK9","editButton":"secondaryHeader_editButton__nYbQe"};